import { useSyncExternalStore } from 'react'

export type TransportMode = 'wifi-hub' | 'mock' | 'web-bluetooth'

export interface AppState {
  online: boolean
  pending: number
  syncing: boolean
  transportMode: TransportMode
  toast?: { kind: 'success' | 'error' | 'info'; message: string }
}

class AppStore {
  private state: AppState = {
    online: navigator.onLine,
    pending: 0,
    syncing: false,
    transportMode: 'wifi-hub',
  }
  private readonly listeners = new Set<() => void>()

  subscribe = (listener: () => void) => {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  snapshot = () => this.state

  patch(patch: Partial<AppState>) {
    this.state = { ...this.state, ...patch }
    this.listeners.forEach(listener => listener())
  }

  notify(kind: NonNullable<AppState['toast']>['kind'], message: string) {
    this.patch({ toast: { kind, message } })
    window.setTimeout(() => {
      if (this.state.toast?.message === message) this.patch({ toast: undefined })
    }, 5000)
  }
}

export const appStore = new AppStore()
window.addEventListener('online', () => appStore.patch({ online: true }))
window.addEventListener('offline', () => appStore.patch({ online: false }))

export function useAppState(): AppState {
  return useSyncExternalStore(appStore.subscribe, appStore.snapshot, appStore.snapshot)
}
